import { AlertColor } from '@mui/material';
import { showAlert } from '../reduxActions/alert';
import { useAppDispatch } from '../storeHook';

export const useDispatchAlert = () => {
  const dispatch = useAppDispatch();
  return (
    content: string,
    severity: AlertColor = 'error'
  ) => {
    dispatch(showAlert({ content, severity }));
  };
};
